<template>
  <el-card>
    <el-form :model="ruleForm" ref="ruleForm" label-position="top" @submit.native.prevent>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="8" :md="8" :lg="6" :xl="6">
          <el-form-item class="no-margin-bottom" :label="$t('cliente')" v-if="userType === '1' || userType === '3'">
            <CustomerList ref="customer" v-model="ruleForm.customer" v-bind:customerType="0" @enter="enter" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <el-form-item :label="$t('etiqueta')" prop="tag">
            <el-input :placeholder="$t('etiqueta')" ref="tag" v-on:keyup.native.enter="search" v-model="ruleForm.tag">
              <el-button slot="append" icon="el-icon-check" @click="search">{{ $t("validar") }}
              </el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <p style="margin-top: 60px; margin-left: 30px; font-weight: bold;"> Quantidade de Etiquetas: {{ tableData.length }} </p>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" v-if="ruleForm.plp !== '0'">
          <el-form-item :label="$t('plp')" prop="plp">
            <el-input :placeholder="$t('plp')" ref="plp" v-model="ruleForm.plp" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" v-if="ruleForm.contract">
          <el-form-item :label="$t('contrato')" prop="contract">
            <el-input :placeholder="$t('contrato')" ref="contract" v-model="ruleForm.contract" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" v-if="ruleForm.contract">
          <el-form-item :label="$t('nome')" prop="contractName">
            <el-input :placeholder="$t('nome')" ref="contractName" v-model="ruleForm.contractName" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table :data="tableData" ref="tableTags" stripe :default-sort="{ prop: 'tag', order: 'ascending' }">
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column sortable prop="tag" :label="$t('etiqueta')" />
      <el-table-column label="Marketplace">
        <template slot-scope="scope">
          <el-select v-model="scope.row.marketplace" placeholder="Selecione">
            <el-option label="MERCADO LIVRE" value="MERCADO LIVRE" />
            <el-option label="SHOPPE" value="SHOPPE" />
            <el-option label="SHEIN" value="SHEIN" />
            <el-option label="B2W DIGITAL" value="B2W DIGITAL" />
            <el-option label="MELHOR ENVIO" value="MELHOR ENVIO" />
            <el-option label="NUVEM SHOP" value="NUVEM SHOP" />
            <el-option label="FRENET" value="FRENET" />
            <el-option label="ELO7" value="ELO7" />
            <el-option label="TIKTOC" value="TIKTOC" />
            <el-option label="VIA VEREJO" value="VIA VEREJO" />
            <el-option label="NETSHOES" value="NETSHOES" />
            <el-option label="MAGALU" value="MAGALU" />
            <el-option label="LOGGI" value="LOGGI" />
            <el-option label="OLX" value="OLX" />
            <el-option label="ALIEXPRESS" value="ALIEXPRESS" />
            <el-option label="ENJOEI" value="ENJOEI" />
            <el-option label="TEMU" value="TEMU" />
            <el-option label="OUTROS" value="OUTROS" />
          </el-select>
        </template>
      </el-table-column>
    </el-table>
    <div class="bottom clearfix">
      <el-button icon="el-icon-check" :disabled="tableData.length === 0" type="success" @click="save">Registrar</el-button>
    </div>
  </el-card>
</template>

<script>
import { ExternalService } from "@/services/customers/external.services";
import { UserService } from "@/services/users/user.services";
import ExternalList from "../../../views/services/plp.external/ExternalList.vue";
import CustomerList from "@/xpost/views/register/customer/CustomerList";

export default {
  name: "PlpExternalRegister",
  components: {
    CustomerList,
    ExternalList
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.userType = response.type;
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
  methods: {
    startup(form) {
      this.ruleForm = form;
    },
    next(el, ev) {
      if (el.target.dataset.next && this.$refs[el.target.dataset.next]) {
        this.$refs[el.target.dataset.next].$el.getElementsByTagName('input')[0].focus();
      } else {
        this.$emit('focus', 'deliveryData');
      }
    },
    enter() {
      this.$refs.plp.$el.getElementsByTagName('input')[0].select();
    },
    hotkey(key) {
      if (+key === 0) {
        key = 10;
      }
      this.$refs.externalList.select(key - 1);
    },
    focus() {
      setTimeout(() => {
        this.$refs.customer.$el.getElementsByTagName('input')[0].select();
      }, 200);
    },
    external(value) {
      const vm = this;
      vm.ruleForm.external = value;
    },
    search() {
      const vm = this;
      if (!vm.ruleForm.tag) {
        return this.$message({ type: "error", message: "É preciso informar a PLP e o Objeto/Rastreio para realizar a pesquisa!" });
      }
      const data = vm.tableData.find(x => x.tag === vm.ruleForm.tag );
      if (data) {
        return this.$message({ type: "error", message: "Etiqueta já registrada!" });
      }
      vm.tableData.push({ 
        tag: vm.ruleForm.tag, 
        marketplace: '' 
      });
      this.$refs.tableTags.toggleAllSelection()
      vm.ruleForm.tag = '';
      this.$refs.tag.$el.getElementsByTagName('input')[0].focus()
/*      
      const loading = vm.$loading(vm.$options.loading);
      ExternalService.plp(vm.ruleForm.plp, vm.ruleForm.tag)
        .then((response) => {
          if (response.status !== 200) {
            return this.$message({ type: "error", message: response.message });
          }
          vm.plpResult = response.data;
          if (vm.plpResult && vm.plpResult.tags) {
            vm.ruleForm.plp = vm.plpResult.plp;
            vm.ruleForm.contract = vm.plpResult.contract;
            vm.ruleForm.contractName = vm.plpResult.contractName;
            vm.tableData = vm.plpResult.tags;
          }
        })
        .catch((error) => {
          this.$message({ type: "error", message: error });
        })
        .finally(() => loading.close());*/
    },
    save() {
      const vm = this;
/*      if (!vm.plpResult) {
        return this.$message({ type: "error", message: "É preciso validar uma PLP antes de realizar o registro!" });
      }*/
      if (vm.userType !== '2' && vm.userType !== '5' && !vm.ruleForm.customer && !vm.customer.id) {
        return this.$message({ type: "error", message: "É preciso informar um cliente para realizar o registro!" });
      }
      /*if (!vm.ruleForm.external) {
        return this.$message({ type: "error", message: "É preciso selecionar um terceiro para realizar o registro!" });
      }*/
      if (vm.$refs.tableTags.selection.length === 0) {
        return this.$message({
          type: "error",
          message: "É preciso selecionar ao menos uma etiqueta apra registro!",
          duration: 5000,
        });
      }

      // const invalid = vm.$refs.tableTags.selection.find(x => !x.marketplace);
      // if (invalid) {
      //   return this.$message({
      //     type: "error",
      //     message: "Todas as etiquetas precisam ter um marketplace selecionado!",
      //     duration: 5000,
      //   });
      // }

      if (!vm.ruleForm.customer) vm.ruleForm.customer = vm.customer.id
      const loading = vm.$loading(vm.$options.loading);
      /*ExternalService.register(vm.ruleForm, vm.$refs.tableTags.selection.map(x => {
        return x.tag;
      })).then(() => {*/
      vm.$bus.$emit("pdv.created", {
        plp: vm.ruleForm.plp,
        list: vm.$refs.tableTags.selection.map(x => ({
          tag: x.tag,
          marketplace: x.marketplace
        })),
        type: 'external',
      });
        vm.tableData = [];
        vm.plpResult = null;
        vm.clear();
        loading.close();
        this.$message({
          type: "success",
          message: "PLP de terceiro registrada com sucesso!",
        });
/*      })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());*/
    },
    clear() {
      this.ruleForm = {
        customer: "",
        plp: "0",
        tag: "",
        external: "",
        contract: "",
        contractName: "",
      };
      this.tableData = [];
      this.tag = "";
      this.plpResult = null;
    }
  },
  props: ['customer'],
  data() {
    return {
      tag: "",
      userType: "2",
      loading: false,
      plpResult: null,
      tableData: [],
      ruleForm: {
        customer: "",
        plp: "0",
        tag: "",
        contract: "",
        contractName: "",
        external: "",
      }
    };
  },
};
</script>